export const HOME = 'HOME'
export const ABOUT = 'ABOUT'
export const PROJECTS = 'PROJECTS'
export const TECH = 'TECH'
export const CONTACT = 'CONTACT'
